import { TransportType } from 'types/QuoteRequest';
import { MaybeUndef } from 'types/UtilityTypes';

// Suggestion and quote payloads don't agree on casing ("AUTO" vs "auto").
export function isAutoTransport(transportType: MaybeUndef<string>): boolean {
  return transportType?.toUpperCase() === TransportType.AUTO;
}
